// extracted by mini-css-extract-plugin
export default {"header":"ManageShareMobile_header__zTYKB"};